module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content notify-content"
  }, [_c('div', {
    staticClass: "row notify-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "title-notify"
  }, [_vm._v("Danh sách thông báo")]), _c('div', {
    staticClass: "check-all",
    on: {
      "click": _vm.onCheckAll
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/faces/done_all.svg")
    }
  }), _c('span', [_vm._v("Đánh dấu tất cả là đã xem")])])]), _c('div', {
    staticClass: "col-md-12 box-notify"
  }, _vm._l((_vm.lstNotify), function(item, index) {
    return _c('div', [_c('div', {
      staticClass: "card",
      style: (item.status === 2 ? 'background:#FBF4D2;' : '')
    }, [_c('div', {
      staticClass: "box-notify-items",
      on: {
        "click": function($event) {
          return _vm.onNotifyItem(item.id)
        }
      }
    }, [_vm._m(0, true), _c('div', {
      staticClass: "content-notify"
    }, [_vm._v(_vm._s(item.short_content)), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(_vm._f("moment")(item.created_at)))])])])])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-avt"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/faces/ic_AvatarDefault.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65c7598d","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notifications/index.vue
// module id = 1588
// module chunks = 0